import React from 'react';
import { Helmet } from 'react-helmet';
// Data for the blog posts
const blogPosts = [
  {
    id: 1,
    imgSrc: '/images/our-fleet/1.jpg',
    date: { day: '14', month: 'June' },
    author: 'TOYOTA ETIOS',
    title: 'Explore Amazing Journeys with TOYOTA ETIOS',
    link: '',
    capacity: '5 Seater',
  },
  {
    id: 2,
    imgSrc: '/images/our-fleet/2.jpg',
    date: { day: '18', month: 'July' },
    author: 'ERITGA',
    title: 'Experience Comfort and Style with ERITGA',
    link: '',
    capacity: '7 Seater',
  },
  {
    id: 3,
    imgSrc: '/images/our-fleet/3.jpg',
    date: { day: '26', month: 'Sep' },
    author: 'SWIFT DESIRE',
    title: 'Discover the Best Adventures with SWIFT DESIRE',
    link: '',
    capacity: '5 Seater',
  },
  {
    id: 4,
    imgSrc: '/images/our-fleet/4.jpg',
    date: { day: '14', month: 'June' },
    author: 'AURA',
    title: 'Plan Your Trip with the Elegant AURA',
    link: '',
    capacity: '5 Seater',
  },
  {
    id: 5,
    imgSrc: '/images/our-fleet/5.jpg',
    date: { day: '18', month: 'July' },
    author: 'INNOVA CRYSTA',
    title: 'Travel in Luxury with INNOVA CRYSTA',
    link: '',
    capacity: '7 Seater',
  },
  {
    id: 6,
    imgSrc: '/images/our-fleet/6.jpg',
    date: { day: '26', month: 'Sep' },
    author: 'SCORPIO',
    title: 'Explore New Horizons with SCORPIO',
    link: '',
    capacity: '7 Seater',
  },
  {
    id: 7,
    imgSrc: '/images/our-fleet/7.jpg',
    date: { day: '26', month: 'Sep' },
    author: 'AUDI',
    title: 'Drive in Style with the Premium AUDI',
    link: '',
    capacity: '5 Seater',
  },
  {
    id: 8,
    imgSrc: '/images/our-fleet/8.jpg',
    date: { day: '26', month: 'Sep' },
    author: 'TAVERA',
    title: 'Reliable and Spacious Travel with TAVERA',
    link: '',
    capacity: '12 Seater',
  },
  {
    id: 9,
    imgSrc: '/images/our-fleet/9.jpg',
    date: { day: '26', month: 'Sep' },
    author: 'KIA Carens',
    title: 'Journey in Comfort with KIA Carens',
    link: '',
    capacity: '7 Seater',
  },
  {
    id: 10,
    imgSrc: '/images/our-fleet/12.jpg',
    date: { day: '26', month: 'Sep' },
    author: 'Honda City',
    title: 'Journey in Comfort with Honda City',
    link: '',
    capacity: '5 Seater',
  },
  {
    id: 11,
    imgSrc: '/images/our-fleet/14.jpg',
    date: { day: '26', month: 'Sep' },
    author: 'Amaze',
    title: 'Journey in Comfort with Amaze',
    link: '',
    capacity: '5 Seater',
  },
  {
    id: 12,
    imgSrc: '/images/our-fleet/15.jpg',
    date: { day: '26', month: 'Sep' },
    author: 'Toyota Corolla',
    title: 'Journey in Comfort with Toyota Corolla',
    link: '',
    capacity: '5 Seater',
  },
  {
    id: 13,
    imgSrc: '/images/our-fleet/16.jpg',
    date: { day: '26', month: 'Sep' },
    author: 'INNOVA',
    title: 'Journey in Comfort with INNOVA',
    link: '',
    capacity: '7 Seater',
  },
  {
    id: 14,
    imgSrc: '/images/our-fleet/10.jpg',
    date: { day: '26', month: 'Sep' },
    author: 'TEMPO TRAVELLER',
    title: 'Group Travel Made Easy with TEMPO TRAVELLER',
    link: '',
    capacity: '13 Seater',
  },
  {
    id: 15,
    imgSrc: '/images/our-fleet/11.jpg',
    date: { day: '26', month: 'Sep' },
    author: 'MINI BUS',
    title: 'Perfect for Large Groups: The MINI BUS',
    link: '',
    capacity: '32 Seater',
  },
];


const OurFleet = () => {
  return (


<div>

<Helmet>
  <title>Contact: +91 8624029699 | AB Ghule Cabs | Pune to Mumbai Cabs | Affordable & Reliable</title>
  <meta name="description" content="Book reliable and affordable Pune to Mumbai cabs with AB Ghule Cabs. One-way, round-trip, airport transfers, and luxury options available. Call +91 8624029699." />
  <meta name="keywords" content="Pune to Mumbai Cab Service, Affordable Cabs Pune to Mumbai, AB Ghule Cabs, Luxury Cabs Pune to Mumbai, Pune to Mumbai cheapest cab, Pune Mumbai Taxi Service, Pune to Mumbai Airport Cabs, Pune to Mumbai Outstation Cabs, Pune to Mumbai Cab Booking Online, Pune Mumbai Express Taxi, Pune to Mumbai Private Cabs, Pune Mumbai One-Way Taxi, Pune to Mumbai Round Trip Cabs, Pune to Mumbai Airport cab, Pune Mumbai Cab, Pune to Mumbai Taxi, Pune to Mumbai Airport Cab Fare, Pune Mumbai Airport Drop, Pune to mumbai cheapest cab, Pune to Mumbai Cab Service, best cab service Pune to Mumbai, Pune to mumbai cab fare, Pune Mumbai taxi service, Pune to Mumbai car, Pune Mumbai taxi fare, Pune to Mumbai international airport cab, Pune to Mumbai cab price, Pune to Mumbai airport cab price, Pune to Mumbai taxi one way, Pune to Mumbai cab booking, Pune to Mumbai airport taxi, Pune Mumbai cab one way" />
  <meta name="robots" content="index, follow" />
  <meta property="og:title" content="Contact: +91 8624029699 | AB Ghule Cabs | Pune to Mumbai Cabs | Affordable & Reliable" />
  <meta property="og:description" content="Book reliable and affordable Pune to Mumbai cabs with AB Ghule Cabs. One-way, round-trip, airport transfers, and luxury options available. Call +91 8624029699." />
  <meta property="og:image" content="https://abghulecabs.com/images/pune-to-mumbai-cabs.jpg" />
  <meta property="og:url" content="https://abghulecabs.com/pune-to-mumbai-cabs" />
  <meta property="og:type" content="website" />
  <meta property="og:site_name" content="AB Ghule Cabs" />
  
  {/* JSON-LD Structured Data for Schema Markup */}
  <script type="application/ld+json">
    {`
      {
        "@context": "https://schema.org",
        "@type": "LocalBusiness",
        "name": "AB Ghule Cabs - Pune to Mumbai Cabs",
        description: "Book reliable and affordable Pune to Mumbai cabs with AB Ghule Cabs. One-way, round-trip, airport transfers, and luxury options available. Call +91 8624029699.",
        "address": {
          "@type": "PostalAddress",
          "streetAddress": "Pune, Maharashtra",
          "addressLocality": "Pune",
          "addressRegion": "Maharashtra",
          "postalCode": "411001",
          "addressCountry": "IN"
        },
        "telephone": "+91-8624029699",
        "url": "https://abghulecabs.com/pune-to-mumbai-cabs",
        "logo": "https://abghulecabs.com/images/pune-to-mumbai-cabs.jpg",
        "image": "https://abghulecabs.com/images/pune-to-mumbai-cabs.jpg",
        "priceRange": "₹1500 - ₹5000",
        "offers": {
          "@type": "Offer",
          "url": "https://abghulecabs.com/pune-to-mumbai-cabs",
          "priceCurrency": "INR",
          "price": "1500",
          "priceValidUntil": "2024-12-31"
        },
        "aggregateRating": {
          "@type": "AggregateRating",
          "ratingValue": "4.8",
          "reviewCount": "1500"
        },
        "review": [
          {
            "@type": "Review",
            "author": {
              "@type": "Person",
              "name": "Sneha Kulkarni"
            },
            "datePublished": "2024-12-22",
            "reviewBody": "Seamless booking process and the ride was very comfortable. Highly recommend AB Ghule Cabs for Pune to Mumbai trips."
          },
          {
            "@type": "Review",
            "author": {
              "@type": "Person",
              "name": "Vishal Sharma"
            },
            "datePublished": "2024-12-18",
            "reviewBody": "Great service at an affordable price. The driver was professional and punctual."
          }
        ],
        "serviceArea": {
          "@type": "Place",
          "name": "Pune and Mumbai",
          "geo": {
            "@type": "GeoCoordinates",
            "latitude": "18.5204",
            "longitude": "73.8567"
          }
        },
        "availableChannel": {
          "@type": "ServiceChannel",
          "serviceUrl": "https://abghulecabs.com/pune-to-mumbai-cabs"
        },
        "keywords": "Pune to Mumbai Cab Service, Affordable Cabs Pune to Mumbai, AB Ghule Cabs, Luxury Cabs Pune to Mumbai, Pune to Mumbai cheapest cab, Pune Mumbai Taxi Service, Pune to Mumbai Airport Cabs, Pune to Mumbai Outstation Cabs, Pune to Mumbai Cab Booking Online, Pune Mumbai Express Taxi, Pune to Mumbai Private Cabs, Pune Mumbai One-Way Taxi, Pune to Mumbai Round Trip Cabs, Pune to Mumbai Airport cab, Pune Mumbai Cab, Pune to Mumbai Taxi, Pune to Mumbai Airport Cab Fare, Pune Mumbai Airport Drop, Pune to mumbai cheapest cab, Pune to Mumbai Cab Service, best cab service Pune to Mumbai, Pune to mumbai cab fare, Pune Mumbai taxi service, Pune to Mumbai car, Pune Mumbai taxi fare, Pune to Mumbai international airport cab, Pune to Mumbai cab price, Pune to Mumbai airport cab price, Pune to Mumbai taxi one way, Pune to Mumbai cab booking, Pune to Mumbai airport taxi, Pune Mumbai cab one way"
      }
    `}
  </script>
</Helmet>
    
<section id="about" className="jarallax text-light">
    <div className="center-y relative text-center">
        <div className="container">
            <div className="row">
                <div className="col-md-12 text-center">
                    <h1 className='text-white'>Our Fleet</h1>
                </div>
                <div className="clearfix"></div>
            </div>
        </div>
    </div>
</section>
    <div className="section-full p-t150 p-b150 site-bg-white twm-blog-grid-2-section-wrap pt-5 ">
      <div className="container">
        <div className="section-content">
         

          <div className="masonry-wrap row ">
            
            {blogPosts.map((post) => (
              <div
                key={post.id}
                className="masonry-item col-xl-4 col-lg-6 col-md-6 m-b30 wow fadeInDown"
                data-wow-delay="0.2"
              >
                <div className="twm-blog-grid-2 ">
                  <div className="wt-post-media borderr">
                    <a href={post.link}>
                      <img src={post.imgSrc} alt={post.title} />
                    </a>
                  </div>
                  <div className="twm-post-info-wrap ">
                    <div className="post-date-wrap">
                    </div>
                    <div className="twm-post-info">
                      <div className="post-author d-flex justify-content-between">
                        <a className="au-name " href={post.link}>
                           {post.author}
                        </a>
                        <a className="au-name" href={post.link}>
                           {post.capacity}
                        </a>
                      </div>
                      <h3 className="post-title">
                        <a href={post.link}>{post.title}</a>
                      </h3>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>

         
        </div>
      </div>
    </div>
</div>
  );
};

export default OurFleet;
